import React from 'react';

const Background = (props) => {
	return (
		<canvas className="three-canvas" id="three-canvas"></canvas>
	)
}

export default Background;



// WEBPACK FOOTER //
// ./src/Components/Background.js